import React from 'react';



type Props = {
  className?: string;
}
export const ArrowBackVector: React.FC<Props> = ({ className }) => {
  return (
    <svg width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path d = 'M16 19L9 12L16 5' stroke = 'currentColor' strokeWidth = '2' strokeLinecap = 'round' strokeLinejoin = 'round'/>
    </svg>
  );
};
